import { POS_OUTLETS, PRODUCTS } from '@/legacy/mocks/seed';
import { useStore } from '@/legacy/store';
import type { PosServices } from '../posContracts';

export const mockPosServices: PosServices = {
  async session() {
    const s = useStore.getState();
    const outlet = POS_OUTLETS[0];
    const shift = s.posShifts.find((sh) => sh.status === 'open');
    return {
      taxRate: 18,
      outletName: outlet?.name ?? 'Outlet',
      shift: shift ? {
        id: shift.id, status: shift.status, outletName: outlet?.name ?? '', cashierName: shift.cashierName,
        openedAt: shift.openedAt, openingFloat: 0, grossSales: shift.grossSales, cashIn: shift.cashIn,
        cashOut: shift.cashOut, netSales: shift.netSales,
      } : null,
      products: PRODUCTS.filter((p) => p.status === 'published').map((p) => ({
        id: p.id, name: p.name, sku: p.sku, price: p.price, stock: p.stock, category: p.categoryId ?? '',
      })),
    };
  },
  async openShift() {
    const outlet = POS_OUTLETS[0];
    useStore.getState().openShift(outlet?.id ?? '', 'cashier', 'Cashier', 0);
    const session = await this.session();
    if (!session.shift) throw new Error('Shift did not open');
    return session.shift;
  },
  async closeShift() {
    const shift = useStore.getState().posShifts.find((s) => s.status === 'open');
    if (shift) useStore.getState().closeShift(shift.id, 0);
  },
  async sale() {},
  async history() {
    return useStore.getState().posShifts.map((shift) => ({
      id: shift.id, status: shift.status, outletName: '', cashierName: shift.cashierName,
      openedAt: shift.openedAt, closedAt: shift.closedAt, openingFloat: 0,
      grossSales: shift.grossSales, cashIn: shift.cashIn, cashOut: shift.cashOut, netSales: shift.netSales,
    }));
  },
  async queue() {
    return useStore.getState().posCommands.map((c) => ({
      id: c.id, type: c.type, status: c.status, createdAt: c.createdAt ?? new Date().toISOString(), shiftId: c.shiftId,
    }));
  },
  async sync() { useStore.getState().syncPosCommands(); },
};
